module.exports = __webpack_public_path__ + "img/edit-background.663fe586.png";